// prutl-frontend-npm6node14/src/pages/RoleManagement.jsx

import React from 'react';
import RoleList from '../components/roleManagement/RoleList.jsx';

const RoleManagement = () => {
  return (
    <div className="roleManagementContainer">
      <h1>Role Management</h1>
      <RoleList />
    </div>
  );
};

export default RoleManagement;
